import { computed, inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import type { Departments } from '../../types';
import { filter, pipe, switchMap } from 'rxjs';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { DepartmentsService } from './departments.service';

type State = {
  departments: Departments;
};

const initialState: State = {
  departments: [],
};

export const DepartmentsStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withComputed(({ departments }) => ({
    options: computed(() =>
      departments().map((department) => ({
        name: department.name,
        value: department.id,
      })),
    ),
  })),
  withMethods((store, api = inject(DepartmentsService)) => ({
    load: rxMethod<void>(
      pipe(
        filter(() => !store.departments().length),
        switchMap(() =>
          api.getDepartments().pipe(
            tapResponse({
              next: (departments) => patchState(store, { departments }),
              error: () => patchState(store, { departments: [] }),
            }),
          ),
        ),
      ),
    ),
  })),
);
